import { Action } from '@ngrx/store';
import { Preferences, UserContext } from '../models/auth';
import { Customer } from '../../core/models/customer';

export const GET = '[User] Get'
export const GET_SUCCESS = '[User] Get Success'
export const GET_FAILED = '[User] Get Failed'

export const SET = '[User] Set'
export const SET_SUCCESS = '[User] Set Success'
export const SET_FAILED = '[User] Set Failed'

export const SELECT_CUSTOMER = '[User] Select Customer'

export const SET_CUSTOMER = '[User] Set Customer'
export const SET_CUSTOMER_SUCCESS = '[User] Set Customer Success'
export const SET_CUSTOMER_FAILED = '[User] Set Customer Failed'

export const SET_LANGUAGE = '[User] Set Language'

export class Get implements Action {
    readonly type = GET
}
export class GetSuccess implements Action {
    readonly type = GET_SUCCESS
    constructor(public payload: UserContext) {}
}
export class GetFailed implements Action {
    readonly type = GET_FAILED
    constructor(public payload: any) {}
}

export class Set implements Action {
    readonly type = SET
    public constructor(public payload: Preferences) {}
}
export class SetSuccess implements Action {
    readonly type = SET_SUCCESS
    constructor(public payload: Preferences) {}
}
export class SetFailed implements Action {
    readonly type = SET_FAILED
    constructor(public payload: any) {}
}

export class SelectCustomer implements Action {
  readonly type = SELECT_CUSTOMER
}

export class SetCustomer implements Action {
  readonly type = SET_CUSTOMER
  public constructor(public payload: string) {}
}
export class SetCustomerSuccess implements Action {
  readonly type = SET_CUSTOMER_SUCCESS
  constructor(public payload: Customer) {}
}
export class SetCustomerFailed implements Action {
  readonly type = SET_CUSTOMER_FAILED
  constructor(public payload: any) {}
}

export class SetLanguage implements Action {
    readonly type = SET_LANGUAGE
    constructor(public payload: string) {}
}

export type Actions =
    Get
    | GetSuccess
    | GetFailed
    | Set
    | SetSuccess
    | SetFailed
    | SelectCustomer
    | SetCustomer
    | SetCustomerSuccess
    | SetCustomerFailed
    | SetLanguage
